const moment = require('moment-timezone');

angular
  .module('eventTimeSaleWashDirect')
  .component('eventTimeSaleWashDirect', {
    template: require('./event-time-sale-wash-direct.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$routeParams', 'AuthService', 'envService',
      function EventTimeSaleWashDirectViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, $routeParams, AuthService, envService) {
        $rootScope.mainmenu = 'eventManagement';
        $rootScope.menu = 'eventDirectTimeSale';
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;

        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.events = [];
        this.totalCount = 0;
        this.curPage = 1;
        this.paging = (page) => {
          this.curPage = page;
          $resource(`${APIURL}/admin/promotion/sale`).get({ page: page - 1 }).$promise
            .then((data) => {
              this.events = data.promotionSales;
              this.totalCount = data.count;
              console.log(this.events);
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.paging(1);
        this.addEvent = () => {
          resetNewEventPayload();
          jQuery('#modal-event-add').modal('show');
        };
        const resetNewEventPayload = () => {
          const today = moment().format('YYYY-MM-DD');
          this.newEvent = { startdate: today, enddate: today, startHour: '10', startMinute: '0', endHour: '11', endMinute: '0', useCoupon: '0', usePoint: '0' };
        };
        this.getStatus = (event) => {
          const todayMoment = moment();
          const endDate = moment(event.ENDDATE_UTC);
          if (event.USEYN === 'N') {
            return 'D';
          } else if (todayMoment.isAfter(endDate)) {
            return 'E';
          }
          return 'A';
        };
        this.isActive = event => this.getStatus(event) === 'A';
        this.onDatePick = () => {
          const startDate = jQuery('#inputPickerStart').val();
          const endDate = jQuery('#inputPickerEnd').val();
          this.newEvent.startdate = moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
          this.newEvent.endDate = moment(endDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        };
        this.submit = () => {
          this.newEvent.fromDate = `${this.newEvent.startdate} ${this.newEvent.startHour}:${this.newEvent.startMinute}`;
          this.newEvent.toDate = `${this.newEvent.enddate} ${this.newEvent.endHour}:${this.newEvent.endMinute}`;
          $resource(`${APIURL}/admin/promotion/sale`).save(this.newEvent).$promise
            .then(() => {
              resetNewEventPayload();
              jQuery('#modal-event-add').modal('hide');
              this.paging(1);
            })
            .catch((err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.delete = (event) => {
          $resource(`${APIURL}/admin/promotion/sale/${event.ID}/disable`).save().$promise
            .then(() => {
              this.paging(this.curPage);
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/event-time-sale-wash-direct/event-time-sale-wash-direct.component.js